import React from "react";
import { NavLink } from "react-router-dom";
// Now correctly imports BRAND from the config file
import { BRAND } from "../config/brandConfig";

/* --- Local nav primitives (Design System Integrated) --- */
function NavItem({ to, label }) {
  const baseStyle = {
    textDecoration: "none",
    color: BRAND.colors.textDark,
    padding: "0.25rem 0.5rem",
    borderRadius: BRAND.radii.full,
  };

  return (
    <NavLink
      to={to}
      style={({ isActive }) => ({
        ...baseStyle,
        // Using BRAND tokens for colors
        backgroundColor: isActive ? BRAND.colors.panelSoft : "transparent",
        color: isActive ? BRAND.colors.accent : BRAND.colors.textDark,
        fontWeight: isActive ? 600 : 500,
      })}
    >
      {label}
    </NavLink>
  );
}

function NavCallToAction({ to, label }) {
  return (
    <NavLink
      to={to}
      style={{
        textDecoration: "none",
        padding: "0.45rem 1rem",
        borderRadius: BRAND.radii.full, // Using design token
        // Using BRAND tokens for gradient colors
        background: `linear-gradient(135deg, ${BRAND.colors.accent}, ${BRAND.colors.accentLight})`,
        color: BRAND.colors.panel, // White
        fontWeight: 600,
        fontSize: 13,
      }}
    >
      {label}
    </NavLink>
  );
}

/* --- Main Header component (Design System Integrated & Final Nav) --- */
function Header() {
  return (
    <header
      style={{
        // Using BRAND tokens for border and background
        borderBottom: `1px solid ${BRAND.colors.border}`,
        backgroundColor: BRAND.colors.panel,
      }}
    >
      <div
        style={{
          maxWidth: BRAND.layout.maxWidth,
          margin: "0 auto",
          padding: `1rem ${BRAND.layout.horizontalPadding}`,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "1.5rem",
        }}
      >
        {/* Brand */}
        <NavLink to="/" style={{ textDecoration: "none", color: "inherit" }}>
          <div
            style={{ display: "flex", alignItems: "center", gap: "0.75rem" }}
          >
            <div
              style={{
                width: 36,
                height: 36,
                borderRadius: BRAND.radii.full, // Using design token
                // Using BRAND tokens for gradient colors
                background: `linear-gradient(135deg, ${BRAND.colors.accent}, ${BRAND.colors.accentLight})`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: BRAND.colors.panel,
                fontWeight: 700,
                fontSize: 18,
              }}
            >
              H
            </div>
            <div>
              <div style={{ fontWeight: 700, fontSize: 18 }}>{BRAND.name}</div>
              <div style={{ fontSize: 12, opacity: 0.7 }}>{BRAND.tagline}</div>
            </div>
          </div>
        </NavLink>

        {/* Desktop Nav - FINAL NAVIGATION (SAGE 5) */}
        <nav style={{ display: "flex", gap: "1.25rem", fontSize: 14 }}>
          {/* FINAL NAV ITEMS */}
          <NavItem to="/" label="Home" />
          <NavItem to="/approach" label="Our Approach" />
          <NavItem to="/services" label="Services" />
          <NavItem to="/clients" label="Who We Serve" />
          <NavItem to="/insights" label="Insights" />
          <NavItem to="/about" label="About" />
          {/* FINAL CTA COPY (UBS Tone) */}
          <NavCallToAction
            to="/contact"
            label="Start a confidential conversation"
          />
        </nav>
      </div>
    </header>
  );
}

export default Header;
